export default "__VITE_ASSET__B0Vowo6h__"